export default "__VITE_ASSET__SnoX6FVD__"